import React from 'react';

/**
 * FAQSchema Component
 * Adds FAQ structured data to pages for rich snippets in Google search results
 * This makes your listing take up MORE space in search results, pushing competitors down
 * 
 * IMPORTANT: This renders inline (not via useEffect) so Google can see it on first crawl
 */
const FAQSchema = ({ faqs }) => {
  if (!faqs || faqs.length === 0) return null;

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <script
      type="application/ld+json"
      data-schema="faq"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
    />
  );
};

export default FAQSchema;
